module.exports = __webpack_public_path__ + "LatoLatin-LightItalic.aad33fba8aa32ab693ec.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-LightItalic.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-LightItalic.eot
// module chunks = styles